import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LpPdfPlayerState {
    isOpen: boolean;
    url: string;
    resource_type: string;
    resource_id: string;
    resource_title: string;
}
const initialState: LpPdfPlayerState = {
    isOpen: false,
    url: '',
    resource_type: '',
    resource_id: '',
    resource_title: '',
};
const LpPdfPlayerSlice = createSlice({
    name: 'LpPdfPlayer',
    initialState,
    reducers: {
        setLpPdfPlayerpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        setLpPdfPlayerUrl: (state, action: PayloadAction<string>) => {
            state.url = action.payload;
        },
        setLpPdfPlayerResourceType: (state, action: PayloadAction<string>) => {
            state.resource_type = action.payload;
        },
        setLpPdfPlayerResourceId: (state, action: PayloadAction<string>) => {
            state.resource_id = action.payload;
        },
        setLpPdfPlayerResourceTitle: (state, action: PayloadAction<string>) => {
            state.resource_title = action.payload
        }
    },
});

export const {
    setLpPdfPlayerpen,
    setLpPdfPlayerUrl,
    setLpPdfPlayerResourceType,
    setLpPdfPlayerResourceId,
    setLpPdfPlayerResourceTitle
} = LpPdfPlayerSlice.actions;
export default LpPdfPlayerSlice.reducer;
